import { component } from 'picoapp';

export default component(async (node) => {
  const video = node.querySelector('video');
  const button = node.querySelector('[data-button]');

  video.addEventListener('play', () => {
    button.hidden = true;
  });

  video.addEventListener('pause', () => {
    button.hidden = false;
  });

  node.addEventListener('click', () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
});
